import { render, staticRenderFns } from "./dictionary.vue?vue&type=template&id=e8d9fd4e&scoped=true"
import script from "./dictionary.vue?vue&type=script&lang=js"
export * from "./dictionary.vue?vue&type=script&lang=js"
import style0 from "./dictionary.vue?vue&type=style&index=0&id=e8d9fd4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d9fd4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d9fd4e')) {
      api.createRecord('e8d9fd4e', component.options)
    } else {
      api.reload('e8d9fd4e', component.options)
    }
    module.hot.accept("./dictionary.vue?vue&type=template&id=e8d9fd4e&scoped=true", function () {
      api.rerender('e8d9fd4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/dictionary.vue"
export default component.exports